import styles from './styles.module.css'



const RollerLoading = ({scale = '0.5', color = 'sk-chase-dot'}) => {
    return (
        <div className={styles['sk-chase']} style={{scale}}>
            <div className={styles[color]}></div>
            <div className={styles[color]}></div>
            <div className={styles[color]}></div>
            <div className={styles[color]}></div>
            <div className={styles[color]}></div>
            <div className={styles[color]}></div>
        </div>
    )
}

export default RollerLoading